import React, { useEffect } from 'react';
import { useSelector } from 'react-redux';

const TRViwerSymbolHelth = () => {
  const { selectedSymbol } = useSelector(state => state.streamCryptoInfo);  

  useEffect(() => {
    
    const script = document.createElement('script');
    script.src = 'https://s3.tradingview.com/external-embedding/embed-widget-technical-analysis.js';
    script.async = true;
    script.innerHTML = JSON.stringify({
      "interval": '1h',
      "width": "400",
      "isTransparent": true,
      "height": "400",
      "symbol": `BINANCE:${selectedSymbol !== '' ? selectedSymbol.replace('-', '') + 'T' : 'BTCUSDT'}`,
      "showIntervalTabs": true,
      "displayMode": "single",
      "locale": "en",
      "colorTheme": "dark"
    });

    const container = document.getElementById('tradingview-container'); 
    if (container) {
      // Remove any existing scripts or content
      while (container.firstChild) {
        container.removeChild(container.firstChild);
      }
      container.appendChild(script);
    }    

    return () => {
      if (container && container.contains(script)) {
        container.removeChild(script);
      }
    };
  }, [selectedSymbol]);

  return (
    <div style={{
      width: '400px', 
      height: '290px',       
      overflow: 'hidden' // Hides the part of the white div that moves outside the blue div
    }}>
      <div style={{         
        width: '400px', 
        height: '400px', 
        position: 'relative', 
        top: '-60px'  // Moves the white div upwards by 30px
      }} >
        <div className="tradingview-widget-container">
          <div id="tradingview-container"></div>
          <div className="tradingview-widget-copyright"></div>
        </div>
      </div>
    </div>
  );
};

export default TRViwerSymbolHelth;